// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderLeftOutlinedSvg from "@fishx/icons-svg/es/asn/BorderLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderLeftOutlined = function BorderLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderLeftOutlinedSvg
  }));
};

BorderLeftOutlined.displayName = 'BorderLeftOutlined';
export default React.forwardRef(BorderLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderLeftOutlined.js
// module id = 2098
// module chunks = 0